export default "__VITE_ASSET__CBO$MOHD__"